'use strict';

import './ProductOverview.less';

import React from 'react';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import PropTypes from 'prop-types';
import { ProductPreview } from '../../ui/system/ProductPreview';
import CloudImageFrame from '../../ui/system/CloudImageFrame';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import VideoModal from 'ck-core-client/source/components/Modal/Video';

export default class ProductOverview extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isVideoModalOpen: false,
			videoId: null,
			showModal: false
		};
	}

	render() {
		return (
			<div className="ProductOverview">
				{this.state.isVideoModalOpen ? (
					<VideoModal
						videoId={this.state.videoId}
						onClose={() => this.setState({ isVideoModalOpen: false })}
					/>
				) : null}

				<div className="minecraft">
					<div className="maxWidthContentWrapper">
						<div className="col-sm-6">
							{/* <CloudImageFrame
								imageName="image-private-server"
								videoFallbackName="image-private-server"
								videoName="product-preview"
							/> */}
							<CloudImageFrame
								imageName="minecraft-kids-landing-screenshot"
								videoFallbackName="minecraft-kids-landing-screenshot"
								videoName="minecraft-landing"
								videoId={'169676431'}
							/>
						</div>

						<div className="col-sm-6">
							<h2 className="title">Code Minecraft Mods</h2>
							<div className="description">
								Programming your own <span className="bold">Minecraft mods</span> has never been
								easier. We provide all the tools and tutorials to write Java code to create
								Minecraft games, we then host for you on your own private server which your friends
								can join.
							</div>

							{/* <RoundButton
								buttonClass="watchVideo"
								handleClick={CK.fn.getNavHandler('/code-your-own-minecraft-mods/')}
								text={'Learn more'}
								colour="blue"
								size="small"
								hoverAnimation="hvr-bounce-in"
							/> */}
						</div>
					</div>
				</div>

				<div className="roblox">
					<div className="maxWidthContentWrapper">
						<div className="col-sm-6">
							<div className="col-sm-6 mobile">
								<CloudImageFrame
									imageName="image-roblox-publish-games"
									videoFallbackName="image-roblox-publish-games"
									videoName="roblox-landing"
									videoId={'169676431'}
								/>
							</div>

							<h2 className="title">Build Roblox Games</h2>

							<div className="description">
								Code, test and then publish your own Roblox games. From building your own Obby to
								launching a tycoon game, we will teach you all the skills you need to build games in
								Roblox Studio.
							</div>

							{/* <RoundButton
								buttonClass="watchVideo"
								handleClick={CK.fn.getNavHandler('/roblox-coding/')}
								text={'Learn more'}
								colour="blue"
								size="small"
								hoverAnimation="hvr-bounce-in"
							/> */}
						</div>

						<div className="col-sm-6 notMobile">
							<CloudImageFrame
								imageName="image-roblox-publish-games"
								videoFallbackName="image-roblox-publish-games"
								videoName="roblox-landing"
								videoId={'246760648'}
							/>
						</div>
					</div>
				</div>

				{/* <div className="productPreview">
					<div className="maxWidthContentWrapper">
						<div className="col-sm-6">
							<ProductPreview
								videoFallbackName="product-preview-screenshot"
								videoName="minecraft-landing"
							/>
						</div>

						<div className="col-sm-6">
							<div className="title">Advanced coding tech for kids</div>
							<div className="description">
								With the Code Kingdoms Code Editor, kids use real Java and Lua code to create their
								own games and projects in Minecraft and Roblox. Switch at any time between
								drag-and-drop blocks and text code (like the pros!). Our video course library will
								show you the ropes, and our Code Editor can track your progress through the courses.
							</div>
						</div>
					</div>
				</div> */}
				{/* <div className="supportVideo">
					<div className="maxWidthContentWrapper">
						<div className="col-sm-6">
							<div className="col-sm-6 mobile">
								<CloudImageFrame
									imageName="jobs-team-screenshot"
									videoFallbackName="jobs-team-screenshot"
									videoName="support-preview-clip"
									onClickVideo={() =>
										this.setState({ isVideoModalOpen: true, videoId: '265344922' })
									}
								/>
							</div>

							<div className="title">Get help when you need it</div>

							<div className="description">
								Worried about getting stuck? We`re on hand 7 days a week to help with everything
								from coding questions to account issues. Get in touch with us at any time and our
								friendly team will get back to you as soon as possible - we promise we can help with
								any question you might have!
								<RoundButton
									handleClick={() =>
										this.setState({
											isVideoModalOpen: true,
											videoId: '265344922'
										})
									}
									icon="button-play-icon"
									text="Learn more"
									colour="yellow"
									size="medium"
									hoverAnimation="hvr-bounce-in"
								/>
							</div>
						</div>

						<div className="col-sm-6 notMobile">
							<CloudImageFrame
								imageName="jobs-team-screenshot"
								videoFallbackName="jobs-team-screenshot"
								videoName="support-preview-clip"
								onClickVideo={() => this.setState({ isVideoModalOpen: true, videoId: '265344922' })}
							/>
						</div>
					</div>
				</div> */}

				{/* <ReactCKImage name="roblox-safety-bottom" forceImgTag={true} extraClasses={['bottom']} /> */}
			</div>
		);
	}
}
